import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import PreviewPDFContainer from '../PreviewPDFContainer/PreviewPDFContainer';
import ShareDegree from '../ShareDegree/ShareDegree';

import classes from './ModalViewPDF.module.css';

const ModalViewPDF = props => {
  const onClickDownloadPDF = (urlDegree, titlePDF) => {
    const link = document.createElement('a');
    link.href = urlDegree;
    link.setAttribute('download', `${titlePDF}.pdf`);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <Dialog
      fullScreen={props.urlViewPDF != '' ? true : false}
      open={props.openModal}
      onClose={props.onCloseModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="lg"
      className={
        props.urlViewPDF != ''
          ? classes.modalDialog
          : classes.modalDialogMini
      }
    >
      <div>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Typography
              variant="h6"
              color="inherit"
              className={classes.flex}
            >
              {props.titlePDF}
            </Typography>
            <ShareDegree
              urlViewPDF={props.urlViewPDF}
              titleCourse={props.titleCourse}
              endDate={props.endDate}
              URLShare={props.URLShare}
            />
            <IconButton
              className={classes.buttonSave}
              onClick={() =>
                onClickDownloadPDF(props.urlViewPDF, props.titlePDF)
              }
            >
              <CloudDownloadIcon
                className={classes.iconNavigation}
              />
            </IconButton>
            <IconButton
              color="inherit"
              onClick={props.onCloseModal}
              aria-label="Close"
            >
              <CloseIcon className={classes.iconNavigation} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <PreviewPDFContainer
          titlePDF={props.titlePDF}
          urlPDF={props.urlViewPDF}
        />
      </div>
    </Dialog>
  );
};

ModalViewPDF.propTypes = {
  // eslint-disable-next-line react/require-default-props
  urlViewPDF: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  openModal: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  onCloseModal: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  titlePDF: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  titleCourse: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  endDate: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  URLShare: PropTypes.string
};

export default ModalViewPDF;
